import React, { useState, useEffect, useRef, createRef } from "react";
import { PopUpCSEXPENSE } from './../../PopUp/PopUpInCome';
import PopupArcode from './../../PopUp/PopUpArcode';
import PopUpOther from './../../PopUp/PopUpOther';
import SelectFix from './../../PopUp/SelectFix';
import PopUpSearchDoc from './../../PopUp/PopUpSearch_acc';
import PopUpSaveMoney from './../../PopUp/PopUpSaveMoney';
// import PopUpOther2 from "./../../PSARDeposit/PopUpOrher";
import PopUpOther2 from './../../PopUp/PopUpOther';
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { parseJwt } from '../../parseJWT';
import { ReDate } from './../../_source/Datefn'
import PopUpReport from './../../PopUp/_fromShow'
import { checkInput } from '../../_source/checkInput'
import Checkdocgroup from './../../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../../CustomFunction/Docno/GetDocno'
import CheckAr from './../../CustomFunction/Csar/GetAr'
import CheckUser from './../../CustomFunction/Csuser/GetUser'
import CheckBrabchname from './../../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../../CustomFunction/Department/Checkname'
import axios from 'axios'
import Backdrop from './../../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import cheackdate from './../../CustomFunction/Date/Checkdate'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import CheckTaxrate from './../../CustomFunction/Docgroup/CheckTaxrate'
import FullScreenDialogs from '../../PopUp/FullScreendialogs/FullScreen'
import SelectDatas from "./../../PopUp/SelectData"
import MaterialUIPickers from "./../../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "./../../Components/Customtopbar/Topbar";
import Inputmultipletax from './../../PopUp/PopUpMultipletax';
import IncomeWithholding from '../../PopUp/FullScreendialogs/Components/IncomeWithholding';
import FullScreenDialognew from "../../Components/CustomDialogs/Fullscreendialog";
import Repostview from "../../Components/Reportview/Repostview";
import Rechecked from "./Components/Rechecked";

const defaultcode = 0;
const listmenu = [
    ["บันทึกใบกำกับภาษีหลายใบ", "Inputmultipletax"],
    ["บันทึกภาษีถูกหัก ณ ที่จ่าย", "IncomeWithholding"],
    ["บันทึกรับเงิน", "save"]
]

export default function PSOtherBad() {
    const Groupdata_code = useRef(null);
    const Groupdata = useRef(null);
    const DeliNumber = useRef(null);
    const CustomerCode = useRef(null);
    const CustomerName = useRef(null);
    const Department_code = useRef(null);
    const Department = useRef(null);
    const Csuser_code = useRef(null);
    const Csuser = useRef(null);
    const Remark = useRef(null);
    const Branch_code = useRef(null);
    const Branch = useRef(null);
    const Deduct = useRef(null);
    const SumPrice = useRef(null);
    const TaxPersen = useRef(null);
    const TaxPrice = useRef(null);
    const valueTax = useRef(null);
    const ValueExcept = useRef(null);
    const TotalPrice = useRef(null);

    const [siteCodeUser, setsiteCodeUser] = useState("");
    const [urlsend, seturlsend] = useState("");
    const [AmountPayable, setAmountPayable] = useState("");
    const [showform, setshowform] = useState("");
    const [PopUpSaveMoney1, setPopUpSaveMoney1] = useState("");
    const [SwitchPopUpCSEXPENSE, setSwitchPopUpCSEXPENSE] = useState("");
    const [SwitchSearchDoc, setSwitchSearchDoc] = useState("");
    const [showPopupOT, setshowPopupOT] = useState("");
    const [SwitchPopupApcode, setSwitchPopupApcode] = useState("");
    const [SwitchOtherPopup, setSwitchOtherPopup] = useState("");
    const [OtPopupType, setOtPopupType] = useState("");
    const [PopUpTYpe, setPopUpTYpe] = useState("");
    const [_saveStatus, set_saveStatus] = useState("");
    const [products, setproducts] = useState([]);
    const [col1, setcol1] = useState("");
    const [col2, setcol2] = useState("");
    const [WHRow1, setWHRow1] = useState("");
    // const [cellValue1, setcellValue1] = useState("");
    const [TBLastClick, setTBLastClick] = useState("");
    const [openBackdrop, setopenBackdrop] = useState(false);
    const [Groupdata_txt, setGroupdata_txt] = useState("");
    const [Department_txt, setDepartment_txt] = useState("");
    const [Branch_txt, setBranch_txt] = useState("");
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    const [siteCodeUser1, setsiteCodeUser1] = useState("");

    const [dataMultipletax, setdataMultipletax] = useState("");
    const [Multipletax, setMultipletax] = useState("");
    const [Withholding, setWithholding] = useState("");
    const [Totaltax, setTotaltax] = useState("");
    const [Docdate1, setDocdate1] = useState("");
    const [Groupcode, setGroupcode] = useState("");
    const [Groupname, setGroupname] = useState("");
    const [Docno, setDocno] = useState("");
    const [Remark1, setRemark1] = useState("");
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [PriceType_code, setPriceType_code] = useState(defaultcode);
    const [defaultselect, setdefaultselect] = useState(defaultcode);
    const [SaleDate, setSaleDate] = useState("");
    const [PROJECT, setPROJECT] = useState("");
    const [checkenableInput, setcheckenableInput] = useState([]);
    const [openReportFullScreenDialog, setopenReportFullScreenDialog] = useState(false);
    const [titleReportFullScreenDialog, settitleFullScreenDialogDialog] = useState("");
    const [reporturl, setreporturl] = useState("");
    const [formPrintdata, setformPrintdata] = useState("");

    const [state, setState] = React.useState({
        arrayBill: [],
        arrayCredit: [],
        arrayexpenses: [],
        arrayotherincome: [],
        Multipletaxdata: [],
        Withholdingdata: [],
        resrecheckeddata: []
    })

    useEffect(() => {
        Cal_Price();
        return () => {
        }
    }, [PriceType_code])

    useEffect(async () => {
        let SITECODESTR = parseJwt(localStorage.getItem('Token'))
        setsiteCodeUser(SITECODESTR.User.SITECODE);
        setsiteCodeUser1(SITECODESTR.User.CODE);
        onAddValue("Branch", SITECODESTR.User.SITECODE);
        setRow(300);
        onAddValue("Csuser", SITECODESTR.User.CODE);
        TaxPersen.current.value = parseFloat(0).toFixed(2)
        Deduct.current.value = parseFloat(0).toFixed(2)
        // setTimeout(() => {
        //     Cal_Price();
        // }, 200)
        await setcheckenableInput(JSON.parse(localStorage.getItem('checkoftxt')))
        await console.log("checkenableInput checkoftxt", checkenableInput.DocDate)
        let mid = new URLSearchParams(location.search).get("mid")
        loadFromindb(mid)

    }, []);

    const loadFromindb = async (mid) => { //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
        console.log("res.data", mid)
        let url = `reportmanage/reportform/${mid}?`
        let res = await axios.get(genURL(url))
        console.log("ressssss", res.data)
        if (res.data.length > 0) {
            await setreporturl(res.data[0].pathname)
            await setformPrintdata(res.data)
        }
    }
    function escapeRegExp(str) {
        if (str) {
            return str.replace(/,/g, " ");
        } else {
            return "";
        }
    }
    //สเตตัส/เงินที่ต้องขำระ/เงินสด/เงินโอน/ตั๋วเงิน/รวมตั๋วเงิน/บัตรเครดิต/ค่าใช้จ่ายรายได้อื่นๆ/รวมรายได้อื่นๆ 
    async function _get_PopUpSaveMoney(status,
        data1,
        data2,
        data3,
        Bill,
        Billsum,
        Credit,
        Creditsum,
        Income,
        Incomesum,
        Expenses,
        Expensessum,
        CHARGEAMOUNT,
        CHARGEPAY1,
        CHARGEPAY2,
        tbBill,
        tbCredit,
        tbotherincome,
        tbexpenses,
        //เพิ่มเติม
        arrayBill,
        arrayCredit,
        arrayexpenses,
        arrayotherincome
    ) {
        await setState({
            arrayBill: arrayBill,
            arrayCredit: arrayCredit,
            arrayexpenses: arrayexpenses,
            arrayotherincome: arrayotherincome
        })
        // console.log("arrayCredit", arrayCredit);
        var CASHAMOUNT = data2;
        var split = data3.split("|");
        console.log(split);
        var BOOKNO = split[0];
        var BANKAMOUNT = split[1];
        var BANKEXPEND = split[2];
        var REMARK = split[3];
        var PAYMENT = data1;
        if (PAYMENT <= 0) {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("ไม่มียอดชำระ")
            return;
        } else {
            await saveData(status, PAYMENT, CASHAMOUNT, BOOKNO, BANKAMOUNT, BANKEXPEND, REMARK,
                Bill, Billsum, Credit, Creditsum, Income, Incomesum, Expenses, Expensessum, CHARGEAMOUNT, CHARGEPAY1, CHARGEPAY2,
                arrayBill,
                arrayCredit,
                arrayexpenses,
                arrayotherincome
            );
        }
    }
    const saveData = async (status, PAYMENT, CASHAMOUNT, BOOKNO, BANKAMOUNT, BANKEXPEND, REMARK,
        Bill, Billsum, Credit, Creditsum, Income, Incomesum, Expenses, Expensessum, CHARGEAMOUNT, CHARGEPAY1, CHARGEPAY2,
        arrayBill,
        arrayCredit,
        arrayexpenses,
        arrayotherincome) => {
        const parameter = new URLSearchParams();
        // var table = [];
        let Items = []
        let SubItems = []
        // var s = [];
        console.log(products.length);
        for (var i = 0; i < products.length && products[i].T_Code; i++) {
            Items[i] = {
                T_Code: products[i].T_Code,
                T_List: products[i].T_List,
                T_Explain: products[i].T_Explain,
                T_Amount: products[i].T_Amount,
                T_Department_Code: products[i].T_Department_Code,
                T_Branch_Code: products[i].T_Branch_Code,
                BTN_T: products[i].BTN_T,
                BTN_W: products[i].BTN_W,
                Projectcode: products[i].PROJECT
            }
            SubItems.push(Items[i])
        }
        // variable : varchar
        parameter.append("listitem", JSON.stringify(SubItems));
        let Withholdingdata = []
        let Withholdingitem = []
        for (let i = 0; i < Withholding.length; i++) {
            if (Withholding[i].Taxinvoice) {
                Withholdingitem[i] = {
                    Taxinvoice: Withholding[i].Taxinvoice,
                    Incometypecode: Withholding[i].Invoicedatecode,
                    Incometypeetxt: Withholding[i].Invoicedatetxt,
                    DateWithholding: Withholding[i].Datetime,
                    PayableCode: Withholding[i].PayableCode,
                    PayableName: Withholding[i].PayableName,
                    Remark: Withholding[i].Remark,
                    Taxrate: Withholding[i].Taxrate,
                    Amountbeforetax: Withholding[i].Amountbeforetax,
                    Tax: Withholding[i].Tax
                }
                Withholdingdata.push(Withholdingitem[i]);
            }
        }
        console.log(Withholdingdata);
        parameter.append("CSARWTAX", !Withholdingdata ? "" : JSON.stringify(Withholdingdata));
        let Multipletaxitem = []
        let Multipletaxdata = []
        for (let i = 0; i < Multipletax.length; i++) {
            if (Multipletax[i].Taxno) {
                Multipletaxitem[i] = {
                    Arcode: Multipletax[i].Arcode,
                    Arname: Multipletax[i].Arname,
                    Beforetax: Multipletax[i].Beforetax,
                    Code: Multipletax[i].Code,
                    Remark: Multipletax[i].Remark,
                    Taxamount: Multipletax[i].Taxamount,
                    Taxdate: Multipletax[i].Taxdate,
                    Taxno: Multipletax[i].Taxno,
                    Totalamount: Multipletax[i].Totalamount,
                    Zerotax: Multipletax[i].Zerotax
                }
                Multipletaxdata.push(Multipletaxitem[i]);
            }
        }
        parameter.append("Multipletax", !Multipletaxdata ? "" : JSON.stringify(Multipletaxdata));
        parameter.append("status", status);
        var POSTBALANCE = ""
        if (Number(BANKEXPEND) > 0) {
            POSTBALANCE = "0"
        }
        if (Number(Creditsum) > 0) {
            POSTBALANCE = "0"
        }
        if (Number(Incomesum) > 0) {
            POSTBALANCE = "0"
        }
        parameter.append("POSTBALANCE", POSTBALANCE);
        parameter.append("CSRECCHQ", !arrayBill ? "" : JSON.stringify(arrayBill));
        parameter.append("CHEQUEAMOUNT", !Billsum ? 0 : Billsum);
        parameter.append("CSRECCREDIT", !arrayCredit ? "" : JSON.stringify(arrayCredit));
        parameter.append("CREDITAMOUNT", !Creditsum ? 0 : Creditsum);
        parameter.append("CHARGEAMOUNT", !CHARGEAMOUNT ? 0 : CHARGEAMOUNT);
        parameter.append("CHARGEPAY1", !CHARGEPAY1 ? 0 : CHARGEPAY1);
        parameter.append("CHARGEPAY2", !CHARGEPAY2 ? 0 : CHARGEPAY2);
        parameter.append("CSRECINCOME", !arrayotherincome ? "" : JSON.stringify(arrayotherincome));
        parameter.append("INCOMEAMOUNT", !Incomesum ? 0 : Incomesum);
        parameter.append("CSRECEXPENSE", !arrayexpenses ? "" : JSON.stringify(arrayexpenses));
        parameter.append("EXPENDAMOUNT", !Expensessum ? 0 : Expensessum);
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("UPDATEUSER", localStorage.getItem('Username'));
        parameter.append("DOCNO", DeliNumber.current.value);
        parameter.append("ARCODE", CustomerCode.current.value);
        parameter.append("ARNAME", CustomerName.current.value);
        parameter.append("REMARK", Remark.current.value);
        parameter.append("DOCGROUP", Groupdata_code.current.value);
        parameter.append("DEPARTMENT", Department_code.current.value);
        parameter.append("PROJECT", PROJECT);
        parameter.append("ALLOCATECODE", "");
        parameter.append("SITECODE", Branch_code.current.value);
        parameter.append("REFDOCNO1", "");
        parameter.append("REFDOCNO2", "");
        parameter.append("USERCODE", localStorage.getItem('Username'));
        parameter.append("DISCWORD2", "");
        parameter.append("BOOKNO", BOOKNO);
        parameter.append("BOOKDESC", REMARK);
        parameter.append("SYSDOCREMARK", "");
        parameter.append("CLOSEREASON", "");
        parameter.append("OWNERCODE", "");
        parameter.append("CURRENCYCODE", "");
        // variable : smallint
        parameter.append("CLOSEFLAG", 0);
        parameter.append("COMMFLAG2", 0);
        parameter.append("MANUALPOST", 0);
        parameter.append("TAXTYPE", PriceType_code);
        parameter.append("MEDIACLEARING", 0);
        // variable : decimal(15, 2)
        parameter.append("SUMAMOUNT1", SumPrice.current.value);
        parameter.append("SUMAMOUNT2", ValueExcept.current.value);
        parameter.append("SUMAMOUNT2B", 0);
        parameter.append("DISCAMOUNT2", 0);
        parameter.append("TAXRATE", TaxPersen.current.value);
        parameter.append("TAXAMOUNT", TaxPrice.current.value);
        parameter.append("TOTALAMOUNT", valueTax.current.value);
        parameter.append("DEBTAMOUNT", TotalPrice.current.value);
        parameter.append("WTAXAMOUNT", 0);
        parameter.append("BANKAMOUNT", BANKAMOUNT);
        parameter.append("BANKEXPEND", BANKEXPEND);
        parameter.append("CASHAMOUNT", CASHAMOUNT);
        parameter.append("CHARGEAMOUNT", 0);
        parameter.append("CHARGEPAY1", 0);
        parameter.append("CHARGEPAY2", 0);
        parameter.append("CHARGETAX", 0);
        parameter.append("DEPOSITAMOUNT", 0);
        parameter.append("SYSDOCFLAG", 0);
        parameter.append("EXCHANGERATE", 0);
        parameter.append("BATHDEBTAMOUNT", 0);
        parameter.append("BATHSUMAMOUNT1", 0);
        parameter.append("BATHSUMAMOUNT2", 0);
        parameter.append("BATHDISCAMOUNT1", 0);
        parameter.append("BATHDISCAMOUNT2", 0);
        parameter.append("BATHTAXAMOUNT", 0);
        parameter.append("BATHTOTALAMOUNT", 0);
        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair[0], "==", pair[1]);
            if (pair[1] === "" && pair[0] === "DOCNO") {
                Uststus = false;
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณาเลือกกลุ่มข้อมูล")
            } else if (pair[1] === "" && pair[0] === "ARCODE") {
                Uststus = false;
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณาเลือกรหัสเจ้าหนี้")
            } else if (pair[1] === "" && pair[0] === "DEPARTMENT") {
                Uststus = false;
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณาเลือกแผนก")
            }
            else if (pair[1] === "" && pair[0] === "SITECODE") {
                Uststus = false;
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณาเลือกสาขา")
            } else if (pair[1] === "" && pair[0] === "PRODUCT2") {
                Uststus = false;
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกข้อมูลในตาราง")
            }
        }
        if (Uststus === false) {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("ข้อมูลไม่ครบ")
        } else if (Uststus === true) {



            setopenBackdrop(true)

            //let url = "/Save?l=0";
            await axios.post(genpostURL("CSOTHERINCOME/Save?l=0"), parameter).then(res => {
                //  await axios.post(genpostURLTEST("/Save?l=0"), parameter).then(res => {
                if (res.data.status === "success") {
                    setopenBackdrop(false)
                    setopensnackbar(true)
                    setColor("success")
                    setIcon(ErrorIcon)
                    setMessagealert("บันทึกสำเร็จ")
                    setTimeout(() => {
                        // ResetThisPage(); 
                        _printReport(res.data.docno)
                    }, 30);
                } else {
                    setopensnackbar(true)
                    setColor("warning")
                    setIcon(ErrorIcon)
                    setMessagealert("บันทึกสำเร็จ" + res.data.status)
                    setopenBackdrop(false)
                }
            }).catch(error => {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("เกิดข้อผิดพลาด" + error)
                setopenBackdrop(false)
            });
        }
    }
    function ResetThisPage() {
        window.location.replace("/PSOtherBad");
    }
    function _saveConnection(e) {
        // console.log(Branch_code.current.value, "testtt");
        if (CustomerCode.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณากรอกรหัสเจ้าหนี้")
            CustomerCode.current.focus()
            return
        } else if (Groupdata_code.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกกลุ่มข้อมูล")
            Groupdata.current.focus()
            return
        } else if (Department_code.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกแผนก")
            return
        } else if (Branch_code.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกสาขา")
            return
        }
        var table = products
        for (let i = 0; i < table.length; i++) {
            // if (table[i].BTN_T === "1" & TaxPersen.current.value !== "0.00") {
            //     setopensnackbar(true)
            //     setColor("warning")
            //     setIcon(ErrorIcon)
            //     setMessagealert("ให้กำหนดรายการภาษีมูลค่าเพิ่มก่อน")
            //     TaxPersen.current.focus()
            //     return
            // }
            if (table[i].T_Code && Number(table[i].T_Amount) <= 0) {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("จำนวนเงินต้องไม่น้อยกว่า 0.00")
                return
            }
            if (table[i].T_Code === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("ให้กำหนดข้อมูลในตารางสินค้าก่อน")
                return
            }
            if (table[i].T_Department_Code === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("ให้กำหนดแผนกก่อน")
                return
            }
            if (table[i].T_Branch_Code === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("ให้กำหนดสาขาก่อน")
                return
            }
        }
        // setPopUpSaveMoney1(!PopUpSaveMoney1)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog("บันทึกรับเงิน")
        settypeFullScreenDialog("SaveMoney")
    }

    /*----------------------------------------------------------------------------------------------------------------------------*/
    const SelectSetData = async (data1, data2, rowIndex) => {
        switch (data1) {
            case "Calendar":
                setSaleDate(data2)
                break;
            case "PriceType":
                if (data2 !== "") {
                    console.log("data2", data2);
                    await setPriceType_code(data2)

                }
                break;
            case "PROJECT":
                //textproject
                console.log(rowIndex);
                if (rowIndex === "") {
                    setPROJECT(data2)
                    //settableproject
                    for (let i = 0; i < products.length; i++) {
                        if (products[i].T_Code) {
                            products[i].PROJECT = data2
                        }
                    }
                }
                // tableproject
                if (rowIndex !== "") {
                    products[Number(rowIndex)].PROJECT = data2
                }
                break;
            default:
                break;
        }
    }
    const pricetype = async (Texttype) => {
        let strTexttype = String(Texttype)
        setdefaultselect([strTexttype])
        await setPriceType_code(strTexttype);

    };

    function Get_PopupArcode(CustomerCode1, CustomerName1, Creditcode, Texttype) {
        CustomerCode.current.value = CustomerCode1;
        CustomerName.current.value = CustomerName1;
    }
    const Get_PopUpOther = async (val) => {
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (OtPopupType) {
            case "Groupdata":
                console.log(data);
                Groupdata_code.current.value = data[0]
                Groupdata.current.value = data[1]
                setGroupdata_txt(data[1])
                await Chackdocno(data[0], "CSOTHERINCOME").then(async (result1) => {
                    console.log(result1);
                    if (result1 !== undefined) {
                        DeliNumber.current.value = await result1
                    } else {
                        DeliNumber.current.value = ""
                    }
                }).finally(_ => {
                    CheckTaxrate(data[0], "CSOTHERINCOME").then((result) => {
                        console.log("sssss", result);
                        TaxPersen.current.value = result
                    })
                }).catch((err) => {
                    DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            case "Department":
                Department_code.current.value = await data[0];
                Department.current.value = await data[1];
                setDepartment_txt(data[1])
                break;
            case "Branch":
                Branch_code.current.value = await data[0];
                Branch.current.value = await data[1];
                setBranch_txt(data[1])
                break;
            default:
                break;
        }
    };
    function CalendarOnChange(data, DateUp) {
        /* var Backup = ""; */
        var today = new Date(data);
        if (DateUp) {
            today.setDate(today.getDate() + DateUp);
        }
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd }
        if (mm < 10) { mm = '0' + mm }
        today = dd + '/' + mm + '/' + (yyyy + 543);

        /* setTimeout(() => {
            Backup = MenuItem;
            setState({ MenuItem: "" });
        }, 0);
        setTimeout(() => {
            setState({ MenuItem: Backup });
        }, 10); */
        return today;
    }
    function _cellButton(cell, row, enumObject, rowIndex) {
        var btn = row.BTN_Code;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={Switch_PopUpCSEXPENSE} onMouseDown={(e) => { setTBLastClick(row.C0) }}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
                    <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
                </div>;
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton2(cell, row, enumObject, rowIndex) {
        var btn = row.BTN_Department;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={SetPopup.bind(null, "Department")} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <i className=""></i>;
                break;
        }
        return (<div>{btnShow}</div>);
    }
    function _cellButton3(cell, row, enumObject, rowIndex) {
        var btn = row.BTN_ฺฺBranch;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={SetPopup.bind(null, "Branch")} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
                    <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
                </div>;
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    function BTN_T(cell, row, enumObject, rowIndex) {
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            var btn = products[rowIndex].BTN_T;
            var btnShowT;
            switch (btn) {
                case "0": btnShowT = <div onClick={T_Status.bind(null, rowIndex, "1")}><i className="far fa-square" style={{ paddingTop: "7px" }}></i></div>; break;
                case "1": btnShowT = <div onClick={T_Status.bind(null, rowIndex, "0")}><i className="far fa-check-square" style={{ paddingTop: "7px" }}></i></div>; break;
                default: btnShowT = ""; break;
            }
            return <div>{btnShowT}</div>;
        }
    }
    function T_Status(Row, Status) {
        var dataArray = products;
        dataArray[Row].BTN_T = Status;
        setproducts(dataArray);
        setTimeout(() => {
            Cal_Price()
        }, 100);
    }
    function BTN_W(cell, row, enumObject, rowIndex) {
        var btnShow = "";
        switch (row.BTN_W) {
            case "0": btnShow = <div onClick={W_Status.bind(null, rowIndex, "1")}><i className="far fa-square" style={{ paddingTop: "7px" }}></i></div>; break;
            case "1": btnShow = <div onClick={W_Status.bind(null, rowIndex, "0")}><i className="far fa-check-square" style={{ paddingTop: "7px" }}></i></div>; break;
            default: btnShow = ""; break;
        }
        return (<div>{btnShow}</div>);
    }

    function W_Status(Row, Status) {
        var dataArray = products;
        dataArray[Row].BTN_W = Status;
        setproducts(dataArray);
    }

    function setRow(data1) {
        var data = [];
        for (var i = 0; i <= data1 - 1; i++) {
            data[i] = { C0: i + 1, }
        }
        setproducts(data);
    }

    function rowClassNameFormat(row, rowIdx) {
        return 'trClassName';
    }
    function onRowClick(row, col, id) {

        let T_Amount = row.T_Amount // จำนวนเต็มเวลาคลิก
        if (col === 5 && T_Amount !== "" && T_Amount !== undefined) {
            row.T_Amount = parseFloat(T_Amount).toFixed(0)
        }

        // ไม่ให้คีย์ข้ามแถ
        setcol1(false);
        setcol2(false);

        // setcellValue1(row.T_Code)
        setWHRow1(id);
        var Pr = products;
        var j = 20;
        for (var i = 0; i < Pr.length; i++) {
            Pr[i].BTN_Code = 0;
            Pr[i].BTN_Department = 0;
            Pr[i].BTN_ฺฺBranch = 0;
        }

        for (var i = products.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
            if (!products[i].T_Code) {
                j = i;
            }
        }//หา แถวที่ว่างบนสุดใน products Table
        if (col === 1 && (j === id || row.T_Code !== undefined)) {
            setcol1(true)
            Pr[id].BTN_Code = 1;
        } else if (col === 6 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            Pr[id].T_Department = Pr[id].T_Department_Code;
            Pr[id].BTN_Department = 1;
        } else if (col === 9 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            Pr[id].T_Branch = Pr[id].T_Branch_Code;
            Pr[id].BTN_ฺฺBranch = 1;
        }
        setproducts(Pr);
        // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            setcol2(true);
            // BTN วันที่
        }
    }

    function onAfterSaveCell(row, cellName, cellValue) {
        // ทศนิยม 2 ตำแหน่ง จำนวนเงิน
        let T_Amount = row.T_Amount
        if (cellName === "T_Amount" && T_Amount !== "") {
            row.T_Amount = parseFloat(T_Amount).toFixed(2)
            setTimeout(() => { Cal_Price() }, 250);
        }
        //end
        // var cellValue2 = cellValue1
        if (cellName === 'T_Code' && cellValue !== "" /* && cellValue2 !== cellValue */) {
            var col = products;
            col[row.C0 - 1] = [];
            col[row.C0 - 1].C0 = row.C0;
            col[row.C0 - 1].BTN_Code = row.BTN_Code;
            setproducts(col);
            AddDataTable(cellValue, row.C0 - 1);
        } else if (cellName === 'T_Code' && cellValue === "") {
            setTimeout(() => { ReLoadData(); }, 250);
        } else if (cellName !== 'T_Code') {
            ReLoadData();
        }

        if (cellName === "T_Department" && cellValue !== "") {
            CheckDepartmentname(cellValue).then(async (result) => {
                if (result !== "") {
                    row.T_Department_Code = await cellValue
                    row.T_Department = result
                    ReLoadData();
                } else {
                    row.T_Department_Code = "";
                    row.T_Department = "";
                    ReLoadData();
                }
            }).catch(error => {
                row.T_Department_Code = "";
                row.T_Department = "";
                ReLoadData();
                console.log(error);
            });
        }
        if (cellName === "T_Department" && cellValue === "") {
            row.T_Department_Code = "";
            row.T_Department = "";
        }
        if (cellName === "T_Branch" && cellValue !== "") {
            CheckBrabchname(cellValue).then((result) => {
                if (result !== "") {
                    row.T_Branch_Code = cellValue
                    row.T_Branch = result
                    ReLoadData();
                } else {
                    row.T_Branch_Code = "";
                    row.T_Branch = "";
                    ReLoadData();
                }
            }).catch(error => {
                row.T_Branch_Code = "";
                row.T_Branch = "";
                ReLoadData();
                console.log(error);
            });
        }
        if (cellName === "T_Branch" && cellValue === "") {
            row.T_Branch_Code = ""
            row.T_Branch = ""
        }
    }

    function Get_PopUpCSEXPENSE(data) {
        AddDataTable(data.code);
    }

    function AddDataTable(ItemCode, row) {
        var j = 20;
        var col = products;
        var url = "CSOTHERINCOME/Searchincome?l=n&Code=" + ItemCode;
        //รหัสซ้ำให้มีอันเดียว//
        // for (var i = 0; i < col.length; i++) {
        //     if (col[i].T_Code === ItemCode) {
        //         setproducts(col);
        //         return
        //     }
        // }
        //----------------------//
        console.log("url", genURL(url));
        axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (row > -1) {
                j = row;
            } else if (TBLastClick && TBLastClick > -1) {
                j = TBLastClick - 1;
            } else {
                for (var i = products.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                    if (!products[i].T_Code) { j = i; }
                }
            }

            console.log("res", res.data)

            if (res.data && res.data.length === 1) {
                col[j] = {
                    C0: j + 1,
                    T_Code: res.data[0].CODE,
                    BTN_Code: col[0].BTN_Code,
                    T_List: res.data[0].MYNAMETH,
                    BTN_T: "0",
                    BTN_W: "0",
                    T_Amount: '0.00',
                    T_Department_Code: Department_code.current.value,
                    T_Department: Department.current.value,
                    T_Branch_Code: Branch_code.current.value,
                    T_Branch: Branch.current.value,
                    PROJECT: PROJECT,
                }
                setproducts(col);
                ReLoadData();
            } else {
                col[j] = {
                    C0: j + 1
                }
                setproducts(col);
                ReLoadData();
            }
        });
    }

    function ReLoadData() { //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา 
        var col = products;
        var NewCol = [];
        var j = 0;
        var Ch = 0;

        for (var i = 0; i < col.length; i++) {
            if (col[i].T_Code) {
                if ((col[i].T_Code)[0] + "" + (col[i].T_Code)[1] === "11") { Ch++; }
                NewCol[j] = col[i];
                NewCol[j].C0 = j + 1;
                /*----------------------------------------------------btn-----*/

                /*------------------------------------------------------------*/
                /* if (Department.current.value) {
                    NewCol[j].T_Department = Department.current.value;
                    NewCol[j].T_Department_Code = Department_code.current.value;
                }
                if (Branch.current.value) {
                    NewCol[j].T_Branch = Branch.current.value;
                    NewCol[j].T_Branch_Code = Branch_code.current.value;
                } */

                if (col[i].T_Branch > col[i].MaxUnit) {
                    if (col[i].MaxUnit <= 0) {
                        col[i].T_Branch = 1;
                    } else {
                        col[i].T_Branch = col[i].MaxUnit
                        setopensnackbar(true)
                        setColor("warning")
                        setIcon(ErrorIcon)
                        setMessagealert(col[i].T_Code + " จำกัดสินค้า " + col[i].MaxUnit + " " + col[i].T_Department)
                    }
                }
                NewCol[j].C9 = (col[i].C7 * col[i].T_Branch) - NewCol[j].C8;
                j++;
            }
        }
        /* if (Ch > 0) {
            setState({ Show_SERIALNUMBER: true });
        } else { setState({ Show_SERIALNUMBER: false }); } */

        for (var i = j; i < col.length; i++) {
            NewCol[j] = { C0: j + 1 };
            j++;
        }
        setproducts(NewCol)
        setTimeout(() => {
            Cal_Price();
        }, 300);

    }

    /*----------------------------------------------------------------------------------------------------------------------------*/
    function Cal_Price() {
        var Sumamount1 = 0; // รวมจำนวนเงิน
        var Sumamount2 = 0; // มูลค่ายกเว้น
        var Debtamount = 0; // รวมทั้งสิ้น
        var Taxrate = 0;
        if (TaxPersen.current.value) {
            Taxrate = parseFloat(TaxPersen.current.value).toFixed(2);
        }
        TaxPersen.current.value = parseFloat(Taxrate).toFixed(2);
        var TaxPersen1 = Number(TaxPersen.current.value);
        // //----------แยกเลือกประเภทการขาย-----------------
        console.log('PriceType_code', PriceType_code);
        var ty_code = String(PriceType_code)
        var CTaxamount = 0;
        var status = '0'
        for (var i = 0; i < products.length; i++) {
            if (products[i].T_Amount) {
                if (products[i].BTN_T === "1") {
                    status = '1'
                    if (ty_code === "0") {
                        Sumamount1 += parseFloat(products[i].T_Amount)
                        CTaxamount = 100
                        Debtamount = Sumamount1 + (TaxPersen1 * Sumamount1 / CTaxamount)
                    } else if (ty_code === "1") {
                        Sumamount1 += parseFloat(products[i].T_Amount)
                        CTaxamount = 100 + TaxPersen1
                        Debtamount = Sumamount1
                    } else if (ty_code === "2") {
                        CTaxamount = 0
                        Sumamount1 += parseFloat(products[i].T_Amount)
                        Debtamount += parseFloat(products[i].T_Amount)
                    }
                } else {
                    if (ty_code === "0") {
                        CTaxamount = 100
                        Sumamount2 += parseFloat(products[i].T_Amount)
                        Debtamount += parseFloat(products[i].T_Amount)
                    } else if (ty_code === "1") {
                        CTaxamount = 100 + TaxPersen1
                        Sumamount2 += parseFloat(products[i].T_Amount)
                        Debtamount += parseFloat(products[i].T_Amount)
                    } else if (ty_code === "2") {
                        CTaxamount = 0
                        Sumamount2 += parseFloat(products[i].T_Amount)
                        Debtamount += parseFloat(products[i].T_Amount)
                    }
                }
            }
        }
        //--------------------------------
        if (ty_code === "2") {
            TaxPrice.current.value = "0.00"
        }
        else if (Sumamount1 !== 0.00) {
            TaxPrice.current.value = parseFloat(TaxPersen1 * Sumamount1 / CTaxamount).toFixed(2)
        } else {
            TaxPrice.current.value = "0.00"
        }
        if (ty_code === "0" && status === '1') {
            valueTax.current.value = parseFloat(Debtamount).toFixed(2)
        } else {
            valueTax.current.value = parseFloat(Sumamount1).toFixed(2)
        }
        SumPrice.current.value = parseFloat(Sumamount1).toFixed(2)
        // valueTax.current.value = parseFloat(Sumamount1).toFixed(2)
        ValueExcept.current.value = parseFloat(Sumamount2).toFixed(2)
        TotalPrice.current.value = parseFloat(Debtamount).toFixed(2);
        setAmountPayable(TotalPrice.current.value);
    }
    //CalPrice Enter
    function Cal_Price1(e) {
        if (e.key === "Enter" && e.target.value !== "") {
            Cal_Price();
        }
    }

    /*------------------------------------------------------------พิเศษ------------------------------------------------------------*/
    const onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata":
                    Checkdocgroup(value, "CSOTHERINCOME", Fix).then(async (result) => {
                        if (result !== "") {
                            Groupdata_code.current.value = value
                            Groupdata.current.value = result
                            setGroupdata_txt(result)
                            if (Fix !== "Y") {
                                await Chackdocno(value, "CSOTHERINCOME").then((result1) => {
                                    if (result1 !== "") {
                                        DeliNumber.current.value = result1
                                    } else {
                                        DeliNumber.current.value = ""
                                    }
                                }).catch((err) => {
                                    DeliNumber.current.value = ""
                                    console.log(err);
                                });
                            }
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            Groupdata_code.current.value = ""
                            Groupdata.current.value = ""
                            setGroupdata_txt("")
                            DeliNumber.current.value = ""
                        }
                    }).finally(_ => {
                        CheckTaxrate(value, "CSOTHERINCOME").then((result) => {
                            console.log("sssss", result);
                            TaxPersen.current.value = result
                        })
                    }).catch((err) => {
                        Groupdata_code.current.value = ""
                        Groupdata.current.value = ""
                        setGroupdata_txt("")
                        DeliNumber.current.value = ""
                        console.log(err);
                    });
                    break;
                case "CustomerCode":
                    await CheckAr(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            CustomerCode.current.value = value
                            CustomerName.current.value = data[0]
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            CustomerCode.current.value = ""
                            CustomerName.current.value = ""
                        }
                    }).catch((err) => {
                        CustomerCode.current.value = ""
                        CustomerName.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Csuser":
                    await CheckUser(value).then(async (result) => {
                        if (result !== "") {
                            Csuser_code.current.value = await value
                            Csuser.current.value = await result
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            Csuser_code.current.value = ""
                            Csuser.current.value = ""
                        }
                    }).catch((err) => {
                        Csuser_code.current.value = ""
                        Csuser.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Department":
                    await CheckDepartmentname(value).then((result) => {
                        if (result !== "") {
                            Department_code.current.value = value
                            Department.current.value = result
                            setDepartment_txt(result)
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            Department_code.current.value = ""
                            Department.current.value = ""
                            setDepartment_txt("")
                        }
                    }).catch((err) => {
                        Department_code.current.value = ""
                        Department.current.value = ""
                        setDepartment_txt("")
                        console.log(err);
                    });
                    break;
                case "Branch":
                    await CheckBrabchname(value).then((result) => {
                        if (result !== "") {
                            Branch_code.current.value = value
                            Branch.current.value = result
                            setBranch_txt(result)
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            Branch_code.current.value = ""
                            Branch.current.value = ""
                            setBranch_txt("")
                        }
                    }).catch((err) => {
                        Branch_code.current.value = ""
                        Branch.current.value = ""
                        setBranch_txt("")
                        console.log(err);
                    });
                    break;
            }
        }
    };
    const _reCHK = async (RowData) => {
        console.log(RowData);
        await setopenFullScreenDialog(false)
        await setopenBackdrop(true)
        let url = "CSOTHERINCOME/Getbycodemain?code=" + RowData[0].docNo;
        console.log(genURL(url));
        let usercode = "";
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data.length > 0) {
                console.log("_reCHK", res.data);
                setState({ resrecheckeddata: res.data, })
                setPROJECT(res.data[0].PROJECT)
                CustomerCode.current.value = res.data[0].ARCODE;
                CustomerName.current.value = res.data[0].ARNAME;
                DeliNumber.current.value = res.data[0].DOCNO;
                onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
                setSaleDate(ReDate(res.data[0].DOCDATE))
                // TexDate.current.value = ReDate(res.data[0].TAXDATE);
                onAddValue("Branch", res.data[0].SITECODE);
                Remark.current.value = res.data[0].REMARK;
                usercode = res.data[0].USERCODE

                onAddValue("Department", res.data[0].DEPARTMENT);
                pricetype(res.data[0].TAXTYPE);
                setPROJECT(res.data[0].PROJECT);
                SumPrice.current.value = res.data[0].TOTALAMOUNT
                TaxPersen.current.value = res.data[0].TAXRATE;
                TaxPrice.current.value = res.data[0].TAXAMOUNT;
                valueTax.current.value = res.data[0].SUMAMOUNT1
                ValueExcept.current.value = res.data[0].SUMAMOUNT2
                TotalPrice.current.value = res.data[0].DEBTAMOUNT
            }
        }).catch(error => {
            console.log(error);
        });

        if (usercode !== "") {
            await onAddValue("Csuser", res.data[0].USERCODE);
        }
        var url1 = "CSOTHERINCOME/Getbycodesub?code=" + RowData[0].docNo;
        console.log(genURL(url1));
        await axios.get(genURL(url1), { timeout: 3600 }).then(async res => {
            if (res.data.length > 0) {
                set_saveStatus(true);
                var data = products;
                for (var i = 0; i < res.data.length; i++) {
                    data[i].T_Code = res.data[i].EXPCODE;
                    data[i].T_List = res.data[i].EXPNAME;
                    data[i].T_Explain = res.data[i].REMARK;
                    data[i].T_Amount = res.data[i].AMOUNT;
                    data[i].BTN_T = String(res.data[i].CALCTAX);
                    data[i].BTN_W = String(res.data[i].CALCWTAX);
                    data[i].T_Department_Code = res.data[i].DEPARTMENT;
                    data[i].PROJECT = res.data[i].PROJECT;
                    await CheckDepartmentname(res.data[i].DEPARTMENT).then(async (result) => {
                        if (result !== "") {
                            data[i].T_Department = await result
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            data[i].T_Department = ""
                        }
                    }).catch((err) => {
                        data[i].T_Department = ""
                        console.log(err);
                    });
                    data[i].T_Branch_Code = res.data[i].SITECODE;
                    await CheckBrabchname(res.data[i].SITECODE).then(async (result) => {
                        if (result !== "") {
                            data[i].T_Branch = await result
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            data[i].T_Branch = ""
                        }
                    }).catch((err) => {
                        data[i].T_Branch = ""
                        console.log(err);
                    });
                }
                await setproducts([...data])
                // await ReLoadData();
            }
        }).catch(error => {
            console.log(error);
        });
        await setopenBackdrop(false)
        await setAmountPayable(TotalPrice.current.value)
        await console.log("AmountPayable", AmountPayable)
    }
    /*----------------------------------------------------------Switch------------------------------------------------------------------*/
    function Switch_PopUpCSEXPENSE() {
        setSwitchPopUpCSEXPENSE(!SwitchPopUpCSEXPENSE);
    }
    function Switch_PopupApcode() {
        setSwitchPopupApcode(!SwitchPopupApcode);
    }
    function Switch_OtherPopup(type) {
        setOtPopupType(type);
        setSwitchOtherPopup(!SwitchOtherPopup);
    }
    function SetPopup(data) {
        setPopUpTYpe(data);
        setshowPopupOT(!showPopupOT);
    };
    function PopUpOtherClose() {
        setshowPopupOT(!showPopupOT);
    };
    function Get_PopUpOther2(data) {
        var DataValue = data.split("|");
        var Pr = products;
        var r = WHRow1;
        switch (PopUpTYpe) {
            case "Department":
                Pr[r].T_Department = DataValue[1];
                Pr[r].T_Department_Code = DataValue[0];
                break;
            case "Branch":
                Pr[r].T_Branch = DataValue[1];
                Pr[r].T_Branch_Code = DataValue[0];
                break;
        }
        setshowPopupOT(!showPopupOT);
        setproducts(Pr);
    };
    // function Switch_Report() {
    //     setState({ SwitchReport: !SwitchReport });
    // }
    function Switch_PopUpSaveMoney() {
        // setPopUpSaveMoney1(!PopUpSaveMoney1);
        setopenFullScreenDialog(false)

    }
    function _print() {
        console.log(DeliNumber.current.value);
        if (DeliNumber.current.value !== "") {
            let url = "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FOtherIncome&standAlone=true&j_username=rpt&j_password=042615116&output=pdf&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&docno=";
            seturlsend(url + DeliNumber.current.value)
            setTimeout(() => {
                switchshowform();
            }, 100);

        }
    }
    function switchshowform(e) {
        setshowform(!showform);
    }
    function onSearch(e) {
        var data = products
        for (var i = 0; i < data.length; i++) {
            data[i].T_Code = "";
            data[i].T_List = "";
            data[i].T_Explain = "";
            data[i].T_Amount = "";
            data[i].T_Department = "";
            data[i].T_Department_Code = "";
            data[i].T_Branch = "";
            data[i].C7 = "";
            data[i].BTN_W = "";
            data[i].BTN_T = "";
            data[i].discount = "";
            data[i].C10 = "";
            setproducts(data);
            /* Cal_Price(); */
        }
    }
    const Chackdoc = () => {
        Chackdocno(Groupdata_code.current.value, "CSOTHERINCOME").then(async (result1) => {
            if (result1 !== undefined) {
                DeliNumber.current.value = await result1
            } else {
                DeliNumber.current.value = ""
            }
        }).catch((err) => {
            DeliNumber.current.value = ""
            console.log(err);
        });
    }

    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e[0]);
        if (typeFullScreenDialog === "IncomeWithholding") {
            setopenFullScreenDialog(e[0])
            if (e[1]) {
                setWithholding([...e[1]])
                // setState("Withholdingdata", [...e[1]])
            }
            if (e[2]) {
                setTotaltax(e[2])
            }
        } else {
            setopenFullScreenDialog(e[0])
            if (e[1]) {
                setMultipletax([...e[1]])
                // setState("Multipletaxdata", [...e[1]])
            }
            if (e[2]) {
                setDocdate1(e[2])
            }
            if (e[3]) {
                setGroupcode(e[3])
            } else if (e[3] === "") {
                setGroupcode("")
            }
            if (e[4]) {
                setGroupname(e[4])
            } else if (e[4] === "") {
                setGroupname("")
            }
            if (e[5]) {
                setDocno(e[5])
            } else if (e[5] === "") {
                setDocno("")
            }
            if (e[6]) {
                CustomerCode.current.value = e[6]
            }
            if (e[7]) {
                CustomerName.current.value = e[7]
            }
            if (e[8]) {
                setRemark1(e[8])
            } else if (e[8] == "") {
                setRemark1("")
            }
        }
    }
    const openDialog = (from) => {
        if (from === "IncomeWithholding") {

            if (SaleDate === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกวันที่ก่อน ...!")
                return
            }
            if (CustomerCode.current.value === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกข้อมูลรหัสลูกหนี้ ...!")
                return
            }
            if (CustomerName.current.value === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกชื่อลูกหนี้ ...!")
                return
            }

            let pram = []
            pram = {
                Defulttb: Withholding,
                Totaltax: Totaltax,
                CustomerCode: CustomerCode.current.value,
                CustomerName: CustomerName.current.value,
                SaleDate: SaleDate,
            }
            setdataMultipletax(pram)
            setopenFullScreenDialog(true)
            settitleFullScreenDialog("บันทึกภาษีถูกหัก ณ ที่จ่าย")
            settypeFullScreenDialog("IncomeWithholding")
        } else if (from === 'search') {
            setopenFullScreenDialog(true)
            settitleFullScreenDialog("ค้นหาบันทึกรายได้อื่นๆ")
            settypeFullScreenDialog(from)
        } else {
            var Data = []
            Data = {
                from: "CSOTHERINCOME",
                userSite: siteCodeUser,
                defult: Multipletax,
                Docdate: Docdate1,
                Groupdata_code: Groupcode,
                Groupdata: Groupname,
                DeliNumber: Docno,
                Code: CustomerCode.current.value,
                Name: CustomerName.current.value,
                Remark: Remark1,
                TaxPersen: TaxPersen.current.value,
                Total: valueTax.current.value,
            }
            setdataMultipletax(Data)

            if (SaleDate === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกวันที่ก่อน ...!")
                return
            }
            if (CustomerCode.current.value === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกข้อมูลรหัสลูกหนี้ ...!")
                return
            }
            if (CustomerName.current.value === "") {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("กรุณากรอกชื่อลูกหนี้ ...!")
                return
            }
            setopenFullScreenDialog(true)
            settitleFullScreenDialog("เลือกใบกำกับภาษีหลายใบ")
            settypeFullScreenDialog("Inputmultipletax")
        }
    }
    const onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    Groupdata.current.value = Groupdata_code.current.value
                    break;
                case "Department":
                    Department.current.value = Department_code.current.value
                    break;
                case "Branch":
                    Branch.current.value = Branch_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "CustomerCode") {
                onAddValue("CustomerCode", e.target.value);
            }
            if (e.target.name === "Department") {
                onAddValue("Department", e.target.value);
            }
            if (e.target.name === "Branch") {
                onAddValue("Branch", e.target.value);
            }
        }
    };
    const onChange = (e) => {
        console.log(e.target.name);
        switch (e.target.name) {
            case "Groupdata":
                if (Groupdata.current.value === "") {
                    setGroupdata_txt("")
                    Groupdata_code.current.value = "";
                    DeliNumber.current.value = "";
                }
                break;
            case "Department":
                if (Department.current.value === "") {
                    setDepartment_txt("")
                    Department_code.current.value = "";
                }
                break;
            case "Branch":
                if (Branch.current.value === "") {
                    setBranch_txt("")
                    Branch_code.current.value = "";
                }
                break;
            case "CustomerCode":
                if (CustomerCode.current.value === "") {
                    CustomerName.current.value = "";
                }
                break;
            default:
                break;
        }
    }
    const onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            Groupdata.current.value = Groupdata_txt;
        }
        if (e.target.name === "Department") {
            Department.current.value = Department_txt;
        }
        if (e.target.name === "Branch") {
            Branch.current.value = Branch_txt;
        }

    };
    const onClickTopbar = (e) => {
        console.log(e);
        switch (e) {
            case "save":
                _saveConnection()
                break;
            case "new":
                ReplacePage(window.location.pathname + location.search)
                break;
            case "print":
                _print(null)
                break;
            case "search":
                //  setSwitchSearchDoc(true);
                openDialog(e)
                break;
            case "Inputmultipletax":
                openDialog()
                break;
            case "IncomeWithholding":
                openDialog("IncomeWithholding")
                break;
            default:
                break;
        }
    }
    const SELECTPROJECT = (cell, row, enumObject, rowIndex) => {
        var btnShow = "";
        if (row.T_Code) {
            btnShow = (
                <div>
                    <SelectDatas
                        origin="PROJECT"  // ประเภท
                        valueSelect={e => SelectSetData("PROJECT", e, String(rowIndex))} // รับค่ากลับ
                        title="-"
                        defaultselect={row.PROJECT}// ค่าเริ่มต้นของ PROJECT
                        opentitle={true}
                    />
                </div >
            )
        }
        return <div>{btnShow}</div>;
    };
    const type = typeFullScreenDialog


    // Report print 
    const _printReport = (docno) => {
        try {
            if (formPrintdata.length > 1) {
                setopensnackbar(true)
                setColor("warning")
                setMessagealert("กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length)
                setIcon(ErrorIcon)
                // this.setState({ opensnackbar: true })
                // this.setState({ color: "warning" })
                // this.setState({ icon: ErrorIcon })

                return;
            }
        } catch (error) {
        }
        if (reporturl !== "") {
            setopenReportFullScreenDialog(true)
            settitleFullScreenDialogDialog("พิมพ์บันทึกรายได้อื่นๆ")
            seturlsend(`${process.env.REACT_APP_REPORTURL}${reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`)

        } else {
            ReplacePage(window.location.pathname + location.search)
        }

    }
    const CloseReportDialog = (e) => {
        setopenReportFullScreenDialog(e)
        ReplacePage(window.location.pathname + location.search)
    }


    const ReplacePage = (e) => {
        setopenBackdrop(false)
        // this.setState({ openBackdrop: false })
        window.location.replace(e);

    };


    return (
        <div className="PSApp" onClick={onClick} onKeyDown={onKeyDown} onChange={onChange} onBlur={onBlur}>
            <FullScreenDialognew open={openReportFullScreenDialog} title={titleReportFullScreenDialog} CloseDialog={e => CloseReportDialog(e)}>
                <Repostview url={urlsend} />
            </FullScreenDialognew>

            <Backdrop open={openBackdrop} />
            <FullScreenDialogs open={openFullScreenDialog} title={titleFullScreenDialog} closeDialog={e => CloseDialog(e)}>
                {type === "Inputmultipletax" ?
                    <Inputmultipletax parm={dataMultipletax}
                        resdata={e => ReturnData(e)}
                        closePopup={e => console.log("closePopup consolee", e)}
                        from="CSOTHERINCOME"
                        recheckeddata={state.resrecheckeddata}

                    /> : null}
                {type === "IncomeWithholding" ?
                    <IncomeWithholding
                        parm={dataMultipletax}
                        resdata={e => ReturnData(e)}
                        from="CSOTHERINCOME"
                        recheckeddata={state.resrecheckeddata}
                    /> : null}
                {type === "SaveMoney" ?
                    <PopUpSaveMoney closePopup={Switch_PopUpSaveMoney}
                        AmountPayable={AmountPayable}
                        from="CSOTHERINCOME"
                        get_PopUpSaveMoney={_get_PopUpSaveMoney}
                        date={SaleDate}
                        pms="I|1|1|1|1|1|1"
                        recheckeddata={state.resrecheckeddata}
                        depositpayment={"0"}
                    /> : null}

                {type === "search" ?
                    <Rechecked Dataselect={e => _reCHK(e)} from="CSOTHERINCOME" />
                    : null}

            </FullScreenDialogs>
            {/* type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog */}
            {showform ? <PopUpReport close={switchshowform} url={urlsend} /> : null}
            {/* {PopUpSaveMoney1 ? <PopUpSaveMoney closePopup={Switch_PopUpSaveMoney}
                AmountPayable={AmountPayable}
                from="CSOTHERINCOME"
                get_PopUpSaveMoney={_get_PopUpSaveMoney}
                date={SaleDate} pms="I|1|1|1|1|1|1" /> : null} */}
            {SwitchPopUpCSEXPENSE ? <PopUpCSEXPENSE closePopup={Switch_PopUpCSEXPENSE} Get_PopUpCSEXPENSE={Get_PopUpCSEXPENSE} /> : null}
            {SwitchSearchDoc ? <PopUpSearchDoc
                closePopup={() => { setSwitchSearchDoc(!SwitchSearchDoc) }}
                Get_Popup={_searchDoc} userSite={siteCodeUser}
                from="CSOTHERINCOME"
            /> : null}
            {/* {SwitchReport ? <PopUpReport closePopup={Switch_Report} /> : null}  */}
            {showPopupOT ? (<PopUpOther2 closePopup={PopUpOtherClose} Get_PopUpOther={Get_PopUpOther2} type={PopUpTYpe} /* Data={valuePopup} */ from="CSARDEPOSIT" />) : null}
            {SwitchPopupApcode ? <PopupArcode closePopup={Switch_PopupApcode} Get_PopUparcode={Get_PopupArcode} /> : null}
            {SwitchOtherPopup ? <PopUpOther closePopup={Switch_OtherPopup} type={OtPopupType} Get_PopUpOther={Get_PopUpOther} userSite="" from="CSOTHERINCOME" /> : null}
            <Topbar
                listmenu={listmenu}
                title="บันทึกรายได้อื่นๆ"
                onClick={e => onClickTopbar(e)}
            />
            <div className="PSAppfrom">
                <Grid>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <Row className="show-grid">
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <MaterialUIPickers title="วันที่เอกสาร"
                                        DateValue={e => SelectSetData("Calendar", e)}
                                        defaultdate={SaleDate}
                                        open={checkenableInput['DOCDATE']}
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon" > กลุ่มข้อมูล</span>
                                            <input type="text" className="form-control hidden" ref={Groupdata_code} />
                                            <input type="text" className="form-control" name="Groupdata" ref={Groupdata}
                                            />
                                            <span id="iconGroupdata" className="input-group-addon icon" onClick={Switch_OtherPopup.bind(null, "Groupdata")} >
                                                <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                            </span>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">เลขที่เอกสาร</span>
                                            <input type="text" className="form-control" ref={DeliNumber} disabled />
                                            <span id="iconTaxNumber" className="input-group-addon icon">
                                                <i className="fas fa-sync-alt" onClick={() => Chackdoc()}></i>
                                            </span>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">รหัสลูกหนี้</span>
                                            <input type="text" className="form-control" name="CustomerCode" ref={CustomerCode}
                                            />
                                            <span onClick={Switch_PopupApcode.bind(null)} id="iconCustomerCode" className="input-group-addon icon">
                                                <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                            </span>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span id="iconCustomerName" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                            <input type="text" className="form-control" disabled ref={CustomerName} />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
            </div>
            <div className="PSAppTable">
                <div className="form-group col-md-12">
                    <div className="form-row">
                        <BootstrapTable
                            data={products}
                            // tableHeaderClass='AppHeaderTable'
                            trClassName='trClassName'
                            tableHeaderClass='trClassName'
                            options={{
                                noDataText: "...",
                                onRowClick: onRowClick,
                            }}

                            cellEdit={{ //แก้ไข
                                mode: 'click',
                                blurToSave: true,
                                /* beforeSaveCell: onBeforeSaveCell, */
                                afterSaveCell: onAfterSaveCell,
                            }}

                            /* keyBoardNav={{
                                enterToEdit: true,
                                customStyle: {
                                    backgroundColor: '#e0e0e0',
                                }
                            }} */
                            height='400'
                        // hover condensed
                        >
                            <TableHeaderColumn row="0" rowSpan="2" dataField='C0' isKey width="35" dataAlign="center"></TableHeaderColumn>
                            <TableHeaderColumn row="0" colSpan="2" dataAlign="left" className="colbuttomhidden" > <div align="center" > รหัส </div> </TableHeaderColumn>
                            <TableHeaderColumn row="1" dataField='T_Code' editable={col1} dataAlign="left" width="100" columnTitle></TableHeaderColumn>
                            <TableHeaderColumn row="1" dataField='BTN_Code' editable={false} dataAlign="center" width="30" dataFormat={_cellButton.bind(this)} columnClassName='columnClassNameFormat1'>    <i id="TableLoadItem" style={{ fontSize: "30" }}></i></TableHeaderColumn>
                            <TableHeaderColumn row="0" rowSpan="2" dataField='T_List' editable={false} dataAlign="left" width="150" columnTitle> <div align="center" > รายการ </div> </TableHeaderColumn>
                            <TableHeaderColumn row="0" rowSpan="2" dataField='T_Explain' editable={col2} dataAlign="left" width="150" columnTitle><div align="center"> อธิบายเพิ่มเติม </div>  </TableHeaderColumn>
                            <TableHeaderColumn row="0" rowSpan="2" dataField='T_Amount' editable={col2} dataAlign="right" width="80" > <div align="center"> จำนวนเงิน </div> </TableHeaderColumn>
                            <TableHeaderColumn row="0" colSpan="2" dataAlign="center" width="60" className="colbuttomhidden" > แผนก </TableHeaderColumn>
                            <TableHeaderColumn row="1" dataField='T_Department' editable={col2} dataAlign="left" width="80" ></TableHeaderColumn>
                            <TableHeaderColumn row="1" dataField='BTN_Department' editable={false} dataAlign="center" width="30" dataFormat={_cellButton2} columnClassName='columnClassNameFormat1'>    <i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                            <TableHeaderColumn row="0" dataField='T_Department_Code' editable={false} dataAlign="center" hidden >  </TableHeaderColumn>
                            <TableHeaderColumn row="0" rowSpan="2" dataField="PROJECT" editable={false} dataAlign="center" dataFormat={SELECTPROJECT.bind(this)} width="150" columnTitle><div align="center"> โครงการ </div></TableHeaderColumn>
                            <TableHeaderColumn row="0" colSpan="2" dataAlign="center" className="colbuttomhidden" columnTitle> สาขา </TableHeaderColumn>
                            <TableHeaderColumn row="1" dataField='T_Branch' editable={col2} dataAlign="left" width="80"  ></TableHeaderColumn>
                            <TableHeaderColumn row="1" dataField='BTN_ฺฺBranch' editable={false} dataAlign="center" width="30" dataFormat={_cellButton3.bind(this)} columnClassName='columnClassNameFormat1'>    <i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                            <TableHeaderColumn row="0" dataField='T_Branch_Code' editable={false} dataAlign="center" hidden > </TableHeaderColumn>
                            <TableHeaderColumn row="0" rowSpan="2" dataField='BTN_T' editable={false} dataAlign="center" width="40" dataFormat={BTN_T.bind(this)}> T </TableHeaderColumn>
                            <TableHeaderColumn row="0" rowSpan="2" dataField='BTN_W' editable={false} dataAlign="center" width="40" dataFormat={BTN_W.bind(this)}> W </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
            <div className="PSAppfrom">
                <Grid>
                    <Col xs={12} sm={8} md={8} lg={8}>
                        <Row className="show-grid">
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">พนักงาน</span>
                                            <input type="text" className="form-control hidden" ref={Csuser_code} />
                                            <input type="text" className="form-control" ref={Csuser} readOnly />
                                            <span id="iconTaxNumber" className="input-group-addon icon">
                                                <i className="fas fa-sync-alt" onClick={() => onAddValue("Csuser", siteCodeUser1)}></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon"> แผนก</span>
                                            <input type="text" className="form-control hidden" ref={Department_code} />
                                            <input type="text" className="form-control" name="Department" ref={Department} />
                                            <span id="iconDepartment" className="input-group-addon icon" onClick={Switch_OtherPopup.bind(null, "Department")}><i > <ArrowDropDownRoundedIcon fontSize="small" /></i></span>
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <SelectDatas
                                                origin="PROJECT"  // โครงการ
                                                valueSelect={e => SelectSetData("PROJECT", e, "")} // รับค่ากลับ
                                                title="โครงการ"
                                                defaultselect={PROJECT}// ค่าเริ่มต้นของ โครงการ
                                            />
                                        </div>
                                    </div>

                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">สาขา</span>
                                            <input type="text" className="form-control hidden" ref={Branch_code} />
                                            <input type="text" className="form-control" name="Branch" ref={Branch} />
                                            <span id="iconBranch" className="input-group-addon icon" onClick={Switch_OtherPopup.bind(null, "Branch")}><i > <ArrowDropDownRoundedIcon fontSize="small" /></i></span>
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <SelectDatas
                                                origin="PriceType"  // ประเภท
                                                valueSelect={e => SelectSetData("PriceType", e)} // รับค่ากลับ
                                                title="ประเภทราคา"
                                                defaultselect={defaultselect}// ค่าเริ่มต้นของ ประเภทราคา
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">หัก ณ ที่จ่าย</span>
                                            <input type="text" className="form-control Price" ref={Deduct} />
                                        </div>
                                    </div>

                                </Row>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">หมายเหตุ</span>
                                            <input type="text" className="form-control" ref={Remark} tabIndex={4} />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>

                                    </div>
                                </Row>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>

                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={4} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">รวมจำนวนเงิน</span>
                                            <input type="" className="form-control Price" ref={SumPrice} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">ภาษีมูลค่าเพิ่ม</span>
                                            <input type="text" className="form-control Price" ref={TaxPersen}  /* value="7.00" */
                                                onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                                                onKeyDown={Cal_Price1}
                                                onBlur={Cal_Price.bind(null)} />
                                            <span className="input-group-addon icon"><i className="fas fa-percentage"></i></span>
                                            <input type="text" className="form-control Price" ref={TaxPrice} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon ">มูลค่ารวมภาษี</span>
                                            <input type="text" className="form-control Price" ref={valueTax} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon"> มูลค่ายกเว้น</span>
                                            <input type="text" className="form-control Price" ref={ValueExcept} disabled />
                                        </div>
                                    </div>
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon"> รวมเงินทั้งสิ้น</span>
                                            <input type="text" className="form-control Price" ref={TotalPrice} disabled />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
                <Snackbar place="br"
                    color={color}
                    icon={icon}
                    autoClose={autoClose}
                    message={messagealert}
                    open={opensnackbar}
                    closeNotification={() => { setopensnackbar(false) }}
                    close />
            </div>
        </div>
    );

}
